import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { AlertController } from "ionic-angular";

const MINUTES_UNITL_AUTO_LOGOUT = 60; // in mins
const CHECK_INTERVAL = 15000; // in ms
const STORE_KEY = "lastAction";
@Injectable()
export class AutoLogoutService {
  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  constructor(private auth: AuthService, private alertCtrl: AlertController) {
    this.reset();
    this.check();
    this.initListener();
    this.initInterval();
  }

  initListener() {
    document.body.addEventListener("click", () => this.reset());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft =
      this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0 && this.auth.jwt !== null;
    if (isTimeout) {
      this.auth.logout().subscribe(result => {
        localStorage.clear();
        const alert = this.alertCtrl.create({
          title: "Du er blevet logget ud",
          message: `Du er blevet automatisk logget ud efter ${MINUTES_UNITL_AUTO_LOGOUT} minutter uden aktivitet.`,
          buttons: ["OK"]
        });
        alert.present();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auto-logout.service.ts